import type React from 'react';
import { useSlides } from '.';
import QuickView from './quickView';
import type { IUncontrolledQuickView } from './shared/types';

const QuickViewWithSlides: React.FC<React.PropsWithChildren<IUncontrolledQuickView>> = (props) => {
    const { onClose } = props;
    const { slideProps } = useSlides();

    return (
        <QuickView
            {...props}
            onClose={() => {
                onClose?.();
            }}
            {...slideProps}
        />
    );
};

export default QuickViewWithSlides;
